import { AddOutlined, ArrowRightAlt, Check, CheckCircleOutline, ChevronRight, Close, DoNotDisturbAltOutlined, DownloadOutlined, VisibilityOutlined } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { CustomButton, FilterBar, TableData } from "components";
import { confirmAlert, errorAlert } from "helpers/alerts";
import { currencyFormatter, downloadFile, hideEmail } from "helpers/util";
import { setTitle } from "redux/slices/uiSlice";
import {
  aplicarAbonoService,
  descartarAbonoService,
  downloadAbonosService,
  getAbonosService,
  getNotificacionesAbonosService,
} from "services/abonos/abonosService";
import { setSession } from "redux/slices/sessionSlice";
import DialogModal from "components/modal/DialogModal";
import { sendTicketAbonoService } from "services/client/bagService";
import html2canvas from "html2canvas";
import Images from "assets/images";
import theme from "config/theme";
import jsPDF from "jspdf";
import Swal from "sweetalert2";


const NotificacionAbonosScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { updateBalance } = useSelector((store) => store.session);
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({});
  const [dialog, setDialog] = useState({ open: false, title: '', body: '' });

  useEffect(() => {
    dispatch(setTitle("Abonos"));
    // eslint-disable-next-line
  }, []);

  const handlerSubmit = async (data) => {
    setLoading(true);
    setFilters(data);
    getNotificacionesAbonosService(data)
      .then((result) => setList(result))
      .catch((error) => errorAlert(error))
      .finally(() => setLoading(false));
  };

  const handlerDownload = () => {
    setLoading(true);
    downloadAbonosService(filters)
      .then((data) => downloadFile(data, "Reporte Abonos.xlsx"))
      .catch((error) => errorAlert(error))
      .finally(() => setLoading(false));
  };


  const applyAbono = (item) => {
    // const hashtag = bag.hashtag.replace('(PDS)', '').replace('(TAE)', '') + ` (${item.type})`;
    confirmAlert({
      title: "¿Aplicar abono?",
      text: "Se registrará el abono en la bolsa destino.",
      onConfirm: () => {
        setLoading(true);
        aplicarAbonoService(item.id)
          .then(({ notification, abono }) => {
            console.log({ notification, abono });
            dispatch(setSession({ updateBalance: updateBalance + 1 }));
            const bag = notification.bag?.hashtag?.replace('(PDS)', '').replace('(TAE)', '') + ` (${notification.bagType})`;
            const commerce = notification.commerce?.username;
            const date = moment().format('DD/MM/YYYY HH:mm:ss');
            setDialog({
              open: true,
              title: "Nuevo abono",
              body:
                <div id="abono">
                  <div className='container-header-logo'>
                    <img alt='logo' className='header-logo' src={Images[theme.code].logo_ticket} />
                  </div>
                  <h4>Comercio: {commerce}</h4>
                  <h4>Bolsa: {bag}</h4>
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td style={{ textAlign: 'right' }}>Fecha y Hora:</td>
                        <td>{date}</td>
                      </tr>
                      <tr>
                        <td style={{ textAlign: 'right' }}>Saldo Inicial:</td>
                        <td>{currencyFormatter.format(abono.saldo_anterior)}</td>
                      </tr>
                      <tr>
                        <td style={{ textAlign: 'right' }}>Importe Abonado:</td>
                        <td>{currencyFormatter.format(notification.amount)}</td>
                      </tr>
                      <tr>
                        <td style={{ textAlign: 'right' }}>Abono de Comisión:</td>
                        <td>{currencyFormatter.format(abono.commission)}</td>
                      </tr>
                      <tr>
                        <td style={{ textAlign: 'right' }}>Saldo Final:</td>
                        <td>{currencyFormatter.format(abono.saldo_final)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>,
              closeText: "Continuar",
              successText: "Descargar",
              onClose: () => {
                navigate(-1);
              },
              onSuccess: () => {
                document.body.appendChild(document.createElement('div')).innerHTML = `
                        <div id="ticket-print"  >
                          <img alt='logo'  src='${Images[theme.code].logo_ticket}' width="200" style="margin-bottom: 30px;" />
                          <h5>Comercio: ${commerce}</h5>
                          <h5 style="margin-bottom: 30px;">Bolsa: ${bag}</h5>
                          <table width="100%">
                            <tr>
                              <td style="text-align: right">Fecha y Hora:</td>
                              <td>${moment().format('DD/MM/YYYY HH:mm:ss')}</td>
                            </tr>
                            <tr>
                              <td style="text-align: right">Saldo Inicial:</td>
                              <td>${currencyFormatter.format(abono.saldo_anterior)}</td>
                            </tr>
                            <tr>
                              <td style="text-align: right">Importe Abonado:</td>
                              <td>${currencyFormatter.format(notification.amount)}</td>
                            </tr>
                            <tr>
                              <td style="text-align: right">Abono de Comisión:</td>
                              <td>${currencyFormatter.format(abono.commission)}</td>
                            </tr>
                            <tr>
                              <td style="text-align: right">Saldo Final:</td>
                              <td>${currencyFormatter.format(abono.saldo_final)}</td>
                            </tr>
                          </table>
                        </div>`;
                html2canvas(document.querySelector('#ticket-print')).then(
                  canvas => {
                    const imgData = canvas.toDataURL('image/png');
                    const pdf = new jsPDF({
                      format: [80, 100],
                      unit: "mm"
                    });
                    pdf.addImage(imgData, 'PNG', 10, 20, 60, 60);
                    pdf.save('comprobante.pdf');
                    document.querySelector('#ticket-print').remove();
                  }
                );
              },
              additionalButton: (
                <Button
                  color='info'
                  onClick={() => {
                    setDialog({ open: false })
                    Swal.fire({
                      title: 'Ingresa el correo electrónico',
                      input: 'text',
                      inputAttributes: {
                        autocapitalize: 'off'
                      },
                      showCancelButton: true,
                      confirmButtonText: 'Enviar',
                      showLoaderOnConfirm: true,
                      cancelButtonColor: "#ED3726",
                      preConfirm: (email) => {
                        return sendTicketAbonoService(bag._id, email, {
                          bag,
                          commerce,
                          date: date,
                          saldo_anterior: abono.saldo_anterior,
                          abono: notification.amount,
                          commission: abono.commission,
                        }).then(() => {
                          confirmAlert({
                            icon: "success",
                            title: "Enviado",
                            text: `Se ha enviado el comprobante del abono al correo electrónico ${hideEmail(email)}`,
                            showCancelButton: false,
                          })
                        }).catch((error) => {
                          Swal.showValidationMessage(error)
                        })
                      },
                      allowOutsideClick: () => !Swal.isLoading()
                    })
                  }}
                  variant="contained"
                >
                  Enviar
                </Button>
              )
            })
            setList(list.map((abono) => abono.id === item.id ? { ...abono, status: "Aplicado" } : abono));
          })
          .catch((error) => errorAlert(error))
          .finally(() => setLoading(false));
      },
    });
  };

  const discardAbono = (item) => {
    confirmAlert({
      title: "¿Descartar abono?",
      text: "El abono quedará marcado como descartado.",
      onConfirm: () => {
        setLoading(true);
        descartarAbonoService(item.id)
          .then(() => {
            setList(list.map((abono) => abono.id === item.id ? { ...abono, status: "Descartado" } : abono));
            confirmAlert({
              title: "Listo",
              text: "Abono descartado correctamente.",
              showCancelButton: false,
            });
            // reload();
          })
          .catch((error) => errorAlert(error))
          .finally(() => setLoading(false));
      },
    });
  };



  const openDetailedReport = (item) => {
    const date = moment(item?.appliedDateTime).toDate();
    navigate("/reportes/detallado", {
      state: {
        date: [date, date],
        type: 2,
        commerce: item?.hoster?.id,
      },
    });
  };

  return (
    <>
      <FilterBar
        handlerFilter={handlerSubmit}
        showButton={false}
        showTitle={false}
        defaultValues={{
          status: "Pendiente",
        }}
        filters={[
          {
            type: "select",
            name: "status",
            label: "Estado",
            data: [
              { id: "Pendiente", name: "Pendiente" },
              { id: "Aplicado", name: "Aplicado" },
              { id: "Descartado", name: "Descartado" },
            ],
          },
        ]}
      />
      <Box mt={-5}>
        <TableData
          loading={loading}
          dataRows={list}
          dataTitle={[
            "Banco Origen",
            "Banco Destino",
            "Importe",
            "Bolsa destino",
            "Referencia",
            "Recibo",
            "Deposito",
            "ID comercio",
            "Estado",
          ]}
          // dataTitle={columns}
          formatter={(row) => [
            row?.bankOrigin || "-",
            row?.bankDestination?.bank || "-",
            row?.amount ? currencyFormatter.format(row?.amount || 0) : "-",
            row?.bagType || "-",
            row?.reference || "-",
            row?.receipt ? {
              type: "button",
              value: "Ver",
              action: () => setDialog({
                open: true,
                title: "Recibo de abono",
                body: <img src={`/v3/file/${row.receipt}/`} alt="Recibo de abono" style={{ width: "100%" }} />,
                onClose: () => setDialog({ open: false, title: '', body: '' }),
              }),
            } : null,
            {
              type: "text",
              value: row.date ? moment(row.date).format("DD/MM/YYYY HH:mm:ss") : "",
              title: `Hora de envío de notificación: ${moment(row.createdAt).format("DD/MM/YYYY HH:mm:ss")}`,
            },
            {
              type: "text",
              value: row.hoster?.identification || "",
              title: row.hoster?.username || "",
            },
            row?.status || "-",
          ]}
          headerButtons={[
            <CustomButton
              dark={true}
              icon={<DownloadOutlined />}
              key={"downloadAbonos"}
              name={"Descargar"}
              loading={loading}
              click={handlerDownload}
            />
          ].filter(Boolean)}
          actions={[
            {
              label: "Aplicar",
              icon: <Check />,
              onClick: applyAbono,
              validate: (item) => item.status === "Pendiente",
            },
            {
              label: "Descartar",
              icon: <Close />,
              onClick: discardAbono,
              validate: (item) => item.status === "Pendiente",
            },
            {
              label: "Reporte",
              icon: <ChevronRight />,
              onClick: openDetailedReport,
              validate: (item) => item.status === "Aplicado",
            },
          ].filter(Boolean)}
        />
      </Box>
      <DialogModal {...dialog} />
    </>
  );
};

export default NotificacionAbonosScreen;
